var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"booking-container"},[_c('OperationLogTable',{ref:"booking-table",attrs:{"panelObj":_vm.panelObj},on:{"onClickEdit":_vm._handleClickEdit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }